export const STRIPE_PRE_PAY = 'cdb/payment/stripe/prepay' // 原先的预授权租借
export const STRIPE_RECHARGE = 'cdb/payment/stripe/recharge' // 原先的订单付款
export const STRIPE_PREPAY_SPTOKEN = 'cdb/payment/stripe/multicurrency/preAuth/stripToken' // 目前使用的预授权租借
export const STRIPE_PAYORDER_SPTOKEN = 'cdb/payment/stripe/multicurrency/payOrder/stripToken' // 目前使用的订单付款
export const STRIPE_PAYORDER = 'cdb/payment/stripe/multicurrency/payOrder' // 信用卡订单付款
export const STRIPE_RECHARGE_WALLET = 'cdb/payment/stripe/multicurrency/rechargeWallet' // 创建钱包充值订单

export const STRIPE_PREAUTH_OF_CONFIRM = 'cdb/payment/stripe/multicurrency/preauthOfIntent/payment' // 信用卡预授权租借
export const STRIPE_CLIENTSECRET = 'cdb/payment/stripe/multicurrency/clientSecret' // 获取客户秘钥
export const STRIPE_PREAUTH_AUTO_CONFIRM1 = 'cdb/payment/stripe/authConfirm'
export const STRIPE_PREAUTH_AUTO_CONFIRM = 'cdb/payment/stripe/multicurrency/confirm' // 信用卡确认订单
export const STRIPE_PAYCONFIRM = 'cdb/payment/stripe/multicurrency/payConfirm/payment' // 确认订单-旧

export const PAYPAL_PRE_PAY = 'cdb/payment/paypal/prepay'
export const PAYPAL_RECHARGE = 'cdb/payment/paypal/recharge'
export const PAYPAL_EXC_PAY = 'cdb/payment/paypal/excpay'
export const PAYPAL_PREAUTH = "cdb/payment/paypal/multicurrency/preauth"; // paypal创建预授权订单
export const PAYPAL_CARD_PREAUTH = 'cdb/payment/paypal/multicurrency/preauthWithToken/'
export const PAYPAL_CONFIRM =
  "cdb/payment/paypal/multicurrency/authConfirm"; // paypal确认订单
export const CARD_PREAUTH = 'cdb/payment/stripe/multicurrency/preauthByCard/payment' // 已保存卡租借
export const PAYMODE = 'cdb/cabinet/check/payment' // 获取支付方式列表
export const SAVED_CARD_RENT = 'cdb/payment/stripe/multicurrency/preauthByCard/payment' // 已保存卡租借
export const STRIPE_SAVE_CARD = 'cdb/payment/stripe/multicurrency/saveCardOfIntent' // stripe保存卡
export const STRIPE_SAVE_CARD_CONFIRM = 'cdb/payment/stripe/multicurrency/saveCardConfirm' // stripe保存卡确认
export const SAVED_CARD_TO_RENT = 'cdb/cabinet/savedCardToRent'

export const REMOVE_CARD = 'cdb/user/card/remove' // 删除卡
export const USER_CARD = 'cdb/user/card' // 卡列表

// sumupOnline
export const SUMUP_PAYORDER = 'cdb/payment/sumupOnlinePayment/payOrder' // 订单付款
export const SUMUP_SAVECARDOFINTENT = 'cdb/payment/sumupOnlinePayment/saveCardOfIntent' // 确认订单
// 阿根廷mercadopago
export const MERCADO_SAVECARDCONFIRM = 'cdb/payment/mercadoPago/multiCurrency/saveCardConfirm' // 保存卡
export const MERCADO_PREAUTH = 'cdb/payment/mercadoPago/multiCurrency/preAuthOrder' // 预授权租借
export const MERCADO_RECHARGE = 'cdb/payment/espees/multicurrency/recharge' // 钱包充值
export const MERCADO_PAYORDER = 'cdb/payment/espees/multicurrency/payOrder' // 订单付款
export const MERCADO_VIPORDER = 'cdb/payment/espees/multicurrency/vipOrder' // 购买vip
export const MERCADO_PAYCONFIRM = '/cdb/payment/multicurrency/payment/confirm' // 确认订单
export const MERCADO_PREAUTHORDER = 'cdb/payment/mercadoPago/multiCurrency/preAuthOrder'
export const MERCADO_CARD = 'cdb/payment/mercadoPago/multiCurrency/user/card'

export const PAYZONE_RECHARGE = 'cdb/payment/multicurrency/recharge'

export const ORDER_LIST = '/app/cdb/mine/order/list'
